import { connect } from 'react-redux';
import useTranslation from 'next-translate/useTranslation';
import { AppDispatch, AppRootState } from '@/configureStore';
import { FullPageScrollPane } from '@/components/FullPageScrollPane';
import { CategoryFacets } from '@/pages/mijn-carel-lurvink/catalogus/components/CategoryFacets/CategoryFacets';
import urlsService from '@/services/urls-service';
import { getProducts, closeFacets } from '../stores/productSearchSlice';
import { selectSearchResultCount, selectFacets, selectFacetsOpen } from '../stores/selectors';
import styles from '../Components/SearchResultsList.module.scss';
import type { CategoryFacetsProps } from '@/pages/mijn-carel-lurvink/catalogus/components/CategoryFacets/CategoryFacets';
import type { FacetItem } from '@/pages/mijn-carel-lurvink/catalogus/stores/types';

interface IMapStateToProps extends Omit<CategoryFacetsProps, 'onFacetChange' | 'toggleFacetsOpen' | 'restProps'> {
  facetsOpen?: boolean;
}
export const mapStateToProps = (state: AppRootState, ownProps: any): IMapStateToProps => {
  const facets = selectFacets(state) || [];
  const facetsOpen = selectFacetsOpen(state);
  const productCount = selectSearchResultCount(state);

  return {
    facets: facets?.length > 0 ? facets : ownProps.facets ?? [],
    facetsOpen,
    productCount
  };
};

interface IMapDispatchToProps extends Omit<CategoryFacetsProps, 'facets' | 'isOpen' | 'productCount' | 'restProps' | 'idPrefix'> {
  closeFacets?: () => void;
  openFacets?: () => void;
  facetsOpen?: boolean;
}
const mapDispatchToProps = (dispatch: AppDispatch): IMapDispatchToProps => {
  return {
    onFacetChange: (facetItem: FacetItem) => {
      const apiUrl = urlsService.getUrl(facetItem.urlSet.api);
      return getProducts(dispatch)({ apiUrl });
    },
    closeFacets: () => {
      dispatch(closeFacets());
    }
  };
};

const Facets = (props: any) => {
  const { t } = useTranslation('search');

  const HeaderComponent = (
    <div className="container-fluid d-lg-none">
      <div className="row">
        <div className="col">
          <h1 className="h1">{t('title.filters')}</h1>
        </div>
        <div className="col-auto ml-auto">
          <button type="button" className="btn btn-link pr-0" onClick={() => props.closeFacets()}>
            <span className="fa fa-times text-lg text-theme mr-1"></span>

            <span className="text-sans-serif text-gray-900 text-nowrap">{t('common:button.close')}</span>
          </button>
        </div>
      </div>
    </div>
  );

  const FooterComponent = (
    <div className={`${styles.FacetsModalFooter} d-lg-none p-3`}>
      <button type="button" className="btn btn-primary btn-xl btn-block" onClick={() => props.closeFacets()}>
        {t('button.show-products', { count: props.productCount })}
      </button>
    </div>
  );

  return (
    <FullPageScrollPane PageHeader={HeaderComponent} PageFooter={FooterComponent} isOpen={props.facetsOpen} trueFullScreen>
      <CategoryFacets {...props} />
    </FullPageScrollPane>
  );
};

export const ConnectedCategoryFacets = connect(mapStateToProps, mapDispatchToProps)(Facets);
